import { z } from 'zod';
import { CareDocumentOvercomeChallengeRecommendationSchema } from './CareDocumentOvercomeChallengeRecommendationSchema';
import { requiredString } from '../../../validation';

export const CareDocumentOvercomeChallengeSchema = z.object({
  challenge: requiredString('Challenge is required'),
  recommendations: z
    .array(CareDocumentOvercomeChallengeRecommendationSchema)
    .optional(),
  progress: z.string().nullish(),
});

export type CareDocumentOvercomeChallenge = z.infer<
  typeof CareDocumentOvercomeChallengeSchema
>;
